import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

import salon1 from '../assets/images/salon-1.jpg';
import salon2 from '../assets/images/salon-2.jpg';
import salon3 from '../assets/images/salon-3.jpg';

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const AboutSection = () => {
  const photos = [
    salon1, salon2, salon3,
    salon1, salon2, salon3,
    salon1, salon2, salon3,
    salon1, salon2, salon3,
  ];

  return (
    <Box
      id="about"
      sx={{
        position: 'relative',
        py: { xs: 6, md: 8 },
        background: `
          radial-gradient(circle at 12% 20%, rgba(201,161,74,0.10) 0%, transparent 24%),
          radial-gradient(circle at 88% 78%, rgba(20,36,95,0.10) 0%, transparent 26%),
          linear-gradient(180deg, #ececeb 0%, #e6e6e3 100%)
        `,
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4 } }}>
        <Grid container spacing={{ xs: 4, md: 5 }} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: 5,
                overflow: 'hidden',
                boxShadow:
                  '0 18px 40px rgba(0,0,0,0.10), 0 6px 18px rgba(20,36,95,0.06)',
                border: '1px solid rgba(255,255,255,0.45)',
                background: 'rgba(255,255,255,0.4)',
                p: { xs: 1.2, md: 1.4 },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  animation: `${scroll} 40s linear infinite`,
                  '&:hover': {
                    animationPlayState: 'paused',
                  },
                }}
              >
                {[...photos, ...photos].map((src, index) => (
                  <Box
                    key={index}
                    sx={{
                      minWidth: { xs: '78%', sm: '42%', md: '33%' },
                      mr: 1.5,
                      height: { xs: 210, md: 270 },
                      borderRadius: 3,
                      overflow: 'hidden',
                      flexShrink: 0,
                      position: 'relative',
                      boxShadow: '0 12px 26px rgba(0,0,0,0.08)',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        background:
                          'linear-gradient(180deg, rgba(12,18,38,0.04) 0%, rgba(12,18,38,0.18) 100%)',
                      },
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        zIndex: 1,
                        boxShadow: 'inset 0 0 0 1px rgba(201,161,74,0.14)',
                        pointerEvents: 'none',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={src}
                      alt={`Lindos Beauty ${index + 1}`}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              variant="overline"
              sx={{
                letterSpacing: 2.6,
                textTransform: 'uppercase',
                color: '#b2872f',
                fontWeight: 700,
              }}
            >
              О нас
            </Typography>

            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Playfair Display", serif',
                color: '#14245f',
                mb: 2,
                fontWeight: 700,
                lineHeight: 1.18,
                fontSize: { xs: '1.9rem', md: '2.35rem' },
              }}
            >
              Lindos Beauty — студии красоты
              <br />
              с безупречным сервисом и комфортом
            </Typography>

            <Typography
              sx={{
                mb: 1.5,
                color: '#3f4763',
                lineHeight: 1.8,
                fontSize: { xs: 14.5, md: 15.5 },
              }}
            >
              С 2020 года мы создаём комфортное пространство, в котором
              сочетаются высокий сервис, внимание к деталям и современные
              бьюти-технологии.
            </Typography>

            <Typography
              sx={{
                mb: 1.5,
                color: '#3f4763',
                lineHeight: 1.8,
                fontSize: { xs: 14.5, md: 15.5 },
              }}
            >
              Приходя к нам, вы можете быть уверены, что получите именно тот
              результат, который хотели, а время в студии пройдёт приятно,
              спокойно и эстетично.
            </Typography>

            <Typography
              sx={{
                mb: 3,
                color: '#3f4763',
                lineHeight: 1.8,
                fontSize: { xs: 14.5, md: 15.5 },
              }}
            >
              Мы работаем только с проверенными брендами и регулярно обучаем
              мастеров, чтобы радовать гостей актуальными техниками, высоким
              уровнем комфорта и безупречным результатом.
            </Typography>

            <Grid container spacing={2}>
              {[
                { value: '1 000+', label: 'довольных клиентов' },
                { value: '4+', label: 'года опыта' },
                { value: '10+', label: 'мастеров' },
              ].map((item) => (
                <Grid size={{ xs: 4 }} key={item.label}>
                  <Box
                    sx={{
                      height: '100%',
                      borderRadius: 3,
                      background:
                        'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(249,249,248,0.95) 100%)',
                      p: { xs: 1.5, md: 2 },
                      textAlign: 'center',
                      boxShadow:
                        '0 10px 24px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.7)',
                      border: '1px solid rgba(20,36,95,0.06)',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#14245f',
                        fontWeight: 800,
                        mb: 0.5,
                        fontSize: { xs: '1.05rem', md: '1.2rem' },
                      }}
                    >
                      {item.value}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#667085',
                        lineHeight: 1.5,
                        fontSize: { xs: 11, md: 12 },
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutSection;